module.exports = __webpack_public_path__ + "templates.user-reminder-desktop-d1adc2ca.html";